import * as Icon from "react-feather";

/**
 * Clasificación visual por `tipo` de notificación (ver §4 de
 * docs/FRONTEND_COMPRAS_NOTIFICACIONES.md, en el backend). El backend no
 * entrega severidad, así que se infiere por el nombre del tipo.
 */
export const clasificarNotificacion = (tipo = "") => {
    if (tipo.includes("VENCIDO") || tipo.startsWith("RECHAZADA")) {
        return { severidad: "danger", IconCmp: Icon.AlertOctagon, etiqueta: "Urgente" };
    }
    if (tipo.includes("PROXIMO_A_VENCER")) {
        return { severidad: "warning", IconCmp: Icon.AlertTriangle, etiqueta: "Aviso" };
    }
    if (tipo === "CERRADA") {
        return { severidad: "success", IconCmp: Icon.CheckCircle, etiqueta: "Cerrada" };
    }
    return { severidad: "info", IconCmp: Icon.Bell, etiqueta: "Aviso" };
};

/** `mensaje` llega en HTML simple (`<strong>`) — para toasts/notificaciones
 * nativas del navegador, que no renderizan HTML, se muestra como texto plano. */
export const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "");
